<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { CollectionsStoryblok } from '$types/bloks';
  import HorizontalCollectionCards from './horizontal-collection-cards.svelte';
  import SingleCollectionCard from './single-collection-card.svelte';

  export let content: CollectionsStoryblok;
</script>

<div class="py-2 lg:py-8 space-y-2 lg:space-y-4" use:storyblokEditable={content}>
  {#each content.rows || [] as row}
    {#if row.component === 'single-collection-card'}
      <SingleCollectionCard block={row} />
    {:else if row.component === 'horizontal-collection-cards'}
      <HorizontalCollectionCards block={row} />
    {/if}
  {/each}
</div>
